// src/locales/en/supplier.js
export const supplier = {
  // Page title and descriptions
  manageSuppliers: 'Manage Suppliers',
  viewAndManageSuppliers: 'View and manage your supplier relationships',
  
  // Statistics
  totalSuppliers: 'Total Suppliers',
  activeSuppliers: 'Active Suppliers',
  inactiveSuppliers: 'Inactive Suppliers',
  
  // Actions
  createNewSupplier: 'Create New Supplier',
  createFirstSupplier: 'Create Your First Supplier',
  editSupplier: 'Edit Supplier',
  deleteSupplier: 'Delete Supplier',
  createSupplier: 'Create Supplier',
  updateSupplier: 'Update Supplier',
  
  // Fields
  supplierName: 'Supplier Name',
  contactPerson: 'Contact Person',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  city: 'City',
  country: 'Country',
  taxId: 'Tax ID / NTN',
  paymentTerms: 'Payment Terms',
  creditLimit: 'Credit Limit',
  notes: 'Notes',
  
  // Placeholders
  enterSupplierName: 'Enter supplier company name',
  enterContactPerson: 'Enter contact person name',
  enterEmail: 'Enter email address',
  enterPhone: 'Enter phone number',
  enterAddress: 'Enter physical address',
  enterCity: 'Enter city',
  enterCountry: 'Enter country',
  enterTaxId: 'Enter tax identification number',
  enterPaymentTerms: 'e.g., Net 30, COD',
  enterCreditLimit: 'Enter credit limit',
  enterNotes: 'Additional notes about the supplier...',
  
  // Search and filters
  searchSuppliers: 'Search by name, contact, email, or phone...',
  allStatuses: 'All Statuses',
  filterByCity: 'Filter by city',
  filterByCountry: 'Filter by country',
  
  // Messages
  supplierCreatedSuccessfully: 'Supplier created successfully',
  supplierUpdatedSuccessfully: 'Supplier updated successfully',
  supplierDeletedSuccessfully: 'Supplier deleted successfully',
  supplierMarkedAsInactive: 'Supplier marked as inactive',
  failedToLoadSuppliers: 'Failed to load suppliers',
  failedToCreateSupplier: 'Failed to create supplier',
  failedToUpdateSupplier: 'Failed to update supplier',
  failedToDeleteSupplier: 'Failed to delete supplier',
  
  // Empty states
  noSuppliersYet: 'No Suppliers Found',
  noSuppliersYetDescription: 'Get started by creating your first supplier.',
  noSuppliersFound: 'No Suppliers Found',
  noSuppliersFoundDescription: 'No suppliers match your search criteria. Try adjusting your filters.',
  
  // Delete confirmation
  confirmDelete: 'Are you sure you want to delete "{{name}}"?',
  deleteWarning: 'If this supplier has associated purchase orders, it will be marked as inactive instead of being permanently deleted.',
  
  // Validation
  validation: {
    nameRequired: 'Supplier name is required',
    invalidEmail: 'Invalid email format',
    invalidCreditLimit: 'Credit limit must be a valid positive number',
    fixErrors: 'Please fix the errors in the form'
  },
  activeHint: "Supplier can be selected on new purchase orders",
  inactiveHint: "Supplier is hidden from new purchase orders",
};